
<template>
  <v-card flat>
    <h1>{{ $t('application.welcome.title') }}</h1>

    <h4>{{ $t('application.instructor.welcome.boxTitle') }}</h4>

    <ul>
      <li>
        <p class="pt-1 mb-0">{{ $t('application.instructor.welcome.boxP1') }}</p>
      </li>
      <li>
        <p class="py-0 mb-0">{{ $t('application.instructor.welcome.boxP2') }}</p>
      </li>
      <li>
        <p class="py-0 mb-0">{{ $t('application.instructor.welcome.boxP3') }}</p>
      </li>
    </ul>
    <p class="mt-3">{{ $t("application.instructor.welcome.boxP4") }}
        <span class="text-no-wrap">(<v-icon size="13">$sl-arrow-right</v-icon>)</span>
        {{ $t("application.instructor.welcome.boxP5") }}
      </p>
    <!-- Go to next step -->
    <NextButton class="mt-8" @click="nextStep">{{ $t('tour.next') }}</NextButton>
    <!-- Go to previous step -->
    <BottomNav @clicked="$emit('goToStep', '-1')" />
  </v-card>
</template>

<script>
// Entryform for an instructor who wants to create an application for someone else

import {mapGetters, mapActions} from 'vuex'
import {RulesMixin} from '@/components/mixins'
import API from '@/services/api.js'
import pick from 'lodash/pick'
import MessageBox from '@/components/Common/MessageBox'
import NextButton from '@/components/Common/NextButton'
import BottomNav from '@/components/Application/BottomNav'

// @group Application
// ApplicationThanks component
export default {
  name: 'ApplicationWelcome',

  mixins: [RulesMixin],
  components: {
    MessageBox,
    NextButton,
    BottomNav
  },
  data: () => ({
    application: null,
    fields: ['id', 'country', 'isCompanyApplication', 'companyId', 'step'],
    valid: true
  }),

  created() {
    this.initApplication()
  },

  watch: {
    /**
     * @vuese
     * Used to watch the selectedApplication and call initApplication and fetch professions
     * @arg called with no argument
     */
    selectedApplication: {
      handler: function () {
        this.initApplication()
      },
      deep: true
    }
  },

  computed: {
    ...mapGetters('application', ['currentStep', 'selectedApplication']),
    // ...mapGetters('currentuser', [
    //   'currentUser',
    //   'isAdministratorFor',
    //   'isInstructorFor',
    //   'isDistanceEducationAdministratorFor',
    //   'isCompanyEducationResponsibleFor'
    // ])
    ...mapGetters('currentuser', ['currentUser'])
  },
  methods: {
    ...mapActions('application', ['setSelectedApplication', 'updateSelectedApplication']),
    /**
     * @vuese
     * Used to Initialize application with either selected or empty application
     */
    initApplication() {
      if (this.selectedApplication && this.selectedApplication.id) {
        this.application = pick(this.selectedApplication, this.fields)
      } else {
        this.application = Object.fromEntries(
          this.fields.map(f => {
            return [f, null]
          })
        )
      }
      //- And add defaults
      this.application.country = 'SE'
      this.application.step = this.currentStep
    },

    /**
     * @vuese
     * Used to go to the next step if form is valid and update the application with new criterias if application exist or create a new one if application don't exist
     * @arg The argument is an integer value representing company id if company exist
     */
    async nextStep() {
      if (this.application.id && this.application.id > 0) {
        API.updateApplication(this.application.id, {data: this.application})
          .then(() => {
            /**
             * @vuese
             * Used to update application in vuex store
             * @arg The params are current fields of the application
             */
            this.updateSelectedApplication(this.application)
            // Fire +1
            // @arg The argument is a integer representing (in which step to go)
            this.$emit('goToStep', '+1')
          })
          .catch(error => {
            this.$events.fire('showError', this.$t('errors.save-failure'))
          })
      } else {
        this.application.isCompanyApplication = true
        this.application.companyId = this.$route.params.id
        this.application.issuedById = this.currentUser.id
        //- This is the first step, so we should create application if there are none

        API.createApplication({
          data: this.application
        })
          .then(response => {
            /**
             * @vuese
             * Used to set application to  store in vuex
             */
            this.setSelectedApplication(response.data)
            // Fire +1
            // @arg The argument is a integer representing (move one step forward)
            this.$emit('goToStep', '+1')
          })
          .catch(error => {
            this.$events.fire('showError', this.$t('errors.save-failure'))
          })
      }
    }
  }
}
</script>

<style scoped>
</style>
